import { Autoplay, Mousewheel, Navigation } from 'swiper/modules'
import type SwiperCore from 'swiper'
import { GameTile, GameType } from '@blackjackfun/ui-components'
import { ThumbnailCarouselContainer, StyledSwiper, StyledSwiperSlide } from './ThumbnailCarousel.styled'
import { useSlideWidthCalculator } from './ThumbnailCarousel.helper'
import ThumbnailCarouselSkeleton from './ThumbnailCarousel.skeleton'

interface ThumbnailCarouselProps {
  games: GameType[]
  isLoading: boolean
  isMobile: boolean
  onSwiperInit?: (swiper: SwiperCore) => void
  onGameClick: (game: GameType) => void
  autoPlay?: boolean
}

const ThumbnailCarousel = ({
  games,
  isLoading,
  isMobile,
  onSwiperInit,
  onGameClick,
  autoPlay = true,
}: ThumbnailCarouselProps) => {
  const { slideWidth, slideCount, containerRef } = useSlideWidthCalculator(isMobile)

  const handleSwiperInit = (core: SwiperCore) => {
    if (onSwiperInit) {
      onSwiperInit(core)
    }
  }

  // Create autoplay config only if autoPlay is true
  const autoplayConfig = autoPlay ? { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true } : false

  return (
    <ThumbnailCarouselContainer ref={containerRef}>
      {isLoading ? (
        <ThumbnailCarouselSkeleton itemWidth={slideWidth} />
      ) : (
        <StyledSwiper
          autoplay={autoplayConfig}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          spaceBetween={8}
          modules={[...(autoPlay ? [Autoplay] : []), Mousewheel, Navigation]}
          centerInsufficientSlides
          centeredSlidesBounds
          slidesPerView="auto"
          slidesPerGroup={slideCount}
          speed={400}
          touchRatio={1}
          onInit={handleSwiperInit}
        >
          {games.map((game, i) => (
            <StyledSwiperSlide key={i} $slideWidth={slideWidth}>
              <GameTile game={game} onClick={() => onGameClick(game)} />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
      )}
    </ThumbnailCarouselContainer>
  )
}

export default ThumbnailCarousel
